import { render, staticRenderFns } from "./RewardIconNotEarned.vue?vue&type=template&id=5aa8f4a6&"
import script from "./RewardIconNotEarned.vue?vue&type=script&lang=js&"
export * from "./RewardIconNotEarned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports